module.exports = __webpack_public_path__ + "media/images/countryrect/ch-33157784926ee96dfcdb5ea44b45bdae.svg";